import type * as React from 'react';

type TemplateProfileImageProps = {
  fileAttachments?: {
    profileImage?: {
      url?: string | null;
    } | null;
  } | null;
  width: string;
  height: string;
  className?: string;
};

export const TemplateProfileImage: React.FC<TemplateProfileImageProps> = ({
  fileAttachments,
  width,
  height,
  className,
}) => {
  const image = fileAttachments?.profileImage?.url;

  return image ? (
    <img
      className={className}
      src={image}
      width={width}
      height={height}
      alt=""
    />
  ) : null;
};
